// Copyright: IQGeo Limited 2010-2019
import L from 'leaflet';
import myw from 'myWorld/base/core';

/* This is a polygon overlay with permanent shape in pixels. The first latLng is the anchor position
 */
myw.PolygonMarker = L.Polygon.extend({
    options: {
        points: []
    },

    initialize(anchor, points, options) {
        L.Polygon.prototype.initialize.call(this, [anchor], options);

        this._pixelPoints = points;
    },

    /* Only project the centre_pt of the marker.
     * The other points are calculated relative to the centre
     */
    _project() {
        const pxAnchor = this._map.latLngToLayerPoint(this._latlngs[0][0]);
        const pxPoints = this._pixelPoints;
        const pxBounds = new L.Bounds();
        const ring = [];
        this._rings = [ring];
        for (let i = 0, len = pxPoints.length; i < len; i++) {
            ring[i] = new L.Point(pxPoints[i][0] + pxAnchor.x, pxPoints[i][1] + pxAnchor.y);
            pxBounds.extend(ring[i]);
        }

        const w = this._clickTolerance(),
            p = new L.Point(w, w);

        if (this._bounds.isValid() && pxBounds.isValid()) {
            pxBounds.min._subtract(p);
            pxBounds.max._add(p);
            this._pxBounds = pxBounds;
        }
    }
});
